import React, { useState } from "react";
import {
  Box,
  Card,
  FormHelperText,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSendForgotPassword } from "../../api/use-forgot-password";
import { OkDialog } from "../ui/ok-dialog";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
  const { t } = useTranslation(["auth", "validation", "common"]);
  const navigate = useNavigate();

  const schema = yup.object({
    email: yup.string().required(t("required", { field: t("email") })),
  });
  const {
    handleSubmit,
    formState: { errors },
    setError,
    control,
  } = useForm({
    defaultValues: {
      email: "",
    },
    resolver: yupResolver(schema),
  });

  const [{ loading }, execute] = useSendForgotPassword();

  const onSubmit = async (data) => {
    try {
      await execute({
        data: {
          email: data.email,
        },
      });
      setSent(true);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error_message || t("forgotPasswordError");
      setError("apiError", { message: errorMessage });
    }
  };

  const [sent, setSent] = useState(false);

  const handleOnClose = () => {
    navigate("/");
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <Card
          sx={{
            px: 5,
            py: 3,
            width: "400px",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: "auto",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "20px",
              textTransform: "uppercase",
              mt: "15px",
            }}
          >
            {t("forgotPasswordQuestion")}
          </Typography>
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              marginTop: "20px",
            }}
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Controller
              render={({ field }) => (
                <TextField
                  error={!!errors.email}
                  fullWidth
                  size="small"
                  helperText={errors.email?.message}
                  label={t("email")}
                  margin="normal"
                  name="email"
                  type="email"
                  variant="filled"
                  {...field}
                />
              )}
              control={control}
              name="email"
            />
            {errors.apiError && (
              <Box sx={{ mt: 1 }}>
                <FormHelperText error>{errors.apiError.message}</FormHelperText>
              </Box>
            )}
            <LoadingButton
              loading={loading}
              variant="black"
              size="small"
              type="submit"
              sx={{ textTransform: "uppercase", marginTop: "10px" }}
            >
              {t("resetPassword")}
            </LoadingButton>
          </Box>
        </Card>
        <OkDialog
          open={sent}
          onClose={handleOnClose}
          text={t("sendResetPasswordSuccess")}
          buttonText={t("ok")}
        />
      </Box>
    </>
  );
}
